const $ = require("jquery");

function getIntentFromUrl() {
    try {
        return new URLSearchParams(window.location.search).get("intent");
    } catch (e) {
        return null;
    }
}

function submitAiMatcher($form) {
    if (!$form || !$form.length) return false;
    const el = $form.get(0);

    if (el && typeof el.requestSubmit === "function") {
        el.requestSubmit();
        return true;
    }

    const $btn = $form.find(".ai-matcher-submit");
    if ($btn.length) {
        $btn.trigger("click");
        return true;
    }

    if (el) {
        el.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        return true;
    }

    return false;
}

function redirectToResults(resultsUrl, intent) {
    const clean = (intent || "").trim();
    if (!resultsUrl || !clean) return;

    const sep = resultsUrl.indexOf("?") > -1 ? "&" : "?";
    window.location.href = resultsUrl + sep + "intent=" + encodeURIComponent(clean);
}

function initAiMatcherUI() {
    const cfg = window.AI_MATCHER_UI || {};
    const resultsUrl = (cfg.resultsUrl || "").trim();

    // 1. Handle Tag Clicks (Available on any page that has .hero-tags)
    const $heroTags = $(".hero-tags span");
    if ($heroTags.length) {
        $heroTags.off("click.aiHeroTags").on("click.aiHeroTags", function () {
            const text = $(this).text().trim();
            const $intakeForm = $("#ai-intake-form");
            const $intakeInput = $intakeForm.find(".intake-ai-input");

            if ($intakeForm.length && $intakeInput.length) {
                $intakeInput.val(text).trigger("input");
                submitAiMatcher($intakeForm);
                return;
            }

            const $input = $(".ai-matcher-input");

            if ($input.length) $input.val(text);
            if (resultsUrl) {
                redirectToResults(resultsUrl, text);
            }
        });
    }

    // 2. Handle Redirect Form Submission (The search bar logic)
    const $redirectForm = $("#ai-matcher-redirect-form");
    if ($redirectForm.length && resultsUrl) {
        $redirectForm.off("submit.aiMatcherRedirectOnly").on("submit.aiMatcherRedirectOnly", function (e) {
            e.preventDefault();
            const $input = $(this).find(".ai-matcher-input");
            const intent = ($input.val() || "").trim();
            if (!intent) return;
            redirectToResults(resultsUrl, intent);
        });
    }

    // 3. Handle Auto-Submit Logic (On the results/output page)
    const urlIntent = (getIntentFromUrl() || "").trim();
    if (urlIntent) {
        const $scope = $(".ki-ausgabe-ai");
        const $form = $(".ai-matcher-form").first();
        const $input = $(".ai-matcher-input").first();

        // If we are on the results page and have an intent in the URL
        if ($form.length && $input.length) {
            // Only fill and submit if the input is currently empty
            if (!$input.val()) {
                $input.val(urlIntent);
            }

            // Short delay to ensure other scripts/plugins are ready
            setTimeout(() => {
                submitAiMatcher($form);
            }, 700);
        }
    }
}

$(document).ready(initAiMatcherUI);
module.exports = initAiMatcherUI;
